<script>
import axios from "axios"
import { mapState } from "vuex"
import DetailsContainer from "@/components/global/DetailsContainer"
import DetailsTopBar from "@/components/global/DetailsTopBar"
import IncidentModal from "@/components/global/IncidentModal"
import Config from "@/config"
import validation from "@/mixins/validation"
import asset from "../../store/asset"

export default {
  components: {
    DetailsContainer,
    DetailsTopBar,
    IncidentModal,
  },
  mixins: [ validation ],
  data() {
    return {
      debug: false,
      canEditAssetType: false,
      incDisplayName: "",
      productId: 0,
      buttonVariant: "light",
      originalRows: [],
      coreRows: [],
      loaded: false,
      error: "",
      detailsExpanded: true,
      initialized: false,
    }
  },
  computed: {
    ...mapState("auth", ["roles", "email"]),
    detailsTopBarItems() {
      const items = []

      if (this.canEditAssetType) {
        items.push({
          id: "saveRecordButton",
          type: "button",
          label: "Save Record",
          position: "right",
          variant: this.buttonVariant,
        })
      }

      items.push({
        id: "createIncidentButton",
        type: "button",
        label: "Create Incident",
        position: "right",
        variant: this.buttonVariant,
      })

      items.push({
        id: "backToSearchButton",
        type: "button",
        label: "↩ Back to Asset Type Search",
        position: "left",
        variant: this.buttonVariant,
      })

      return items
    },
    incidentGroup() {
      return Config.asset.incidentGroup
    },
  },
  watch: {
    "$route.params.params": {
      immediate: true,
      handler(newId) {
        if (!newId) {
          this.error = "Missing Asset Type ID Parameter"
        } else if (isNaN(newId)) {
          this.error = "Invalid Asset Type ID"
        } else {
          const assetTypeId = parseInt(newId)
          if (this.assetTypeId !== assetTypeId) {
            this.assetTypeId = assetTypeId
            this.updateView()
          }
        }
      },
    },
  },
  created() {
    if (this.debug) console.log("[AssetTypeDetails.vue] created")
    this.canEditAssetType = this.roles.includes("asset.asset")
    //this.canEditAssetType = true
  },
  methods: {
    async updateView() {
      try {
        if (!this.$route.params.params) {
          this.error = "Missing Asset Type ID Parameter"
          return
        }
        
        if (isNaN(this.$route.params.params)) {
          this.error = "Invalid Asset Type ID Format"
          return
        }

        this.assetTypeId = parseInt(this.$route.params.params)
        await this.loadCurrentRecord()
      } catch (err) {
        console.error("[AssetTypeDetails.vue] Error in updateView:", err)
        this.error = `Failed to update view: ${err.message}`
      }
    },
    loadCurrentRecord() {
      if (this.debug) console.log("[AssetTypeDetails.vue] loadCurrentRecord for assetTypeId:", this.assetTypeId)

      this.loaded = false
      this.error = ""

      return this.$store.dispatch("asset/getAssetTypeById", this.assetTypeId)
        .then(data => {
          console.log(data)
          if (!data) {
            throw new Error("No data returned from API")
          }
          this.buildCoreRows(data)
          this.loaded = true
        })
        .catch(error => {
          console.error("[AssetTypeDetails.vue] Error loading product:", error)
          this.error = `Failed to load Asset Type details: ${error.message}`
          this.loaded = false
          throw error
        })
    },
    buildCoreRows(data) {
      const coreRows = [
        {
          items: [
            {
              data: {
                id: "assetTypeId",
                label: "Asset Type Id",
                value: data.assetTypeId || "",
                readOnly: true,
                // message: "Name is required.",
                state: null,
              },
              //   validation: {
              //     rules: {
              //       required: true,
              //     },
              //   },
              type: "text",
              cols: 6,
            },
            {
              data: {
                id: "assetTypeName",
                label: "Asset Type Name",
                value: data.assetTypeName || "",
                readOnly: !this.canEditAssetType,
                // message: "Name is required.",
                state: null,
              },
              //   validation: {
              //     rules: {
              //       required: true,
              //     },
              //   },
              type: "text",
              cols: 6,
            },
            
          ],
        },
        {
          items: [
            {
              data: {
                id: "assetTypeDesc",
                label: "Asset Type Description",
                value: data.assetTypeDesc || "",
                readOnly: !this.canEditAssetType,
              },
              //   validation: {
              //     rules: {
              //       required: false,
              //     },
              //   },
              type: "text",
              cols: 6,
            },
          ],
        },
      ]

      this.originalRows = JSON.parse(JSON.stringify(coreRows))
      this.coreRows = coreRows
      console.log(this.coreRows)
      this.loaded = true
    },
    
    onTopBarButtonClick(id) {
      if (id === "saveRecordButton") {
        // Check for permission to edit.
        if (!this.canEditAssetType) {
          this.$bvToast.toast(`You do not have permission to save changes.`, {
            title: "Asset Type Edit",
            autoHideDelay: 5000,
            variant: "danger",
          })
          return
        }

        if (!this.checkSchemaState(this.coreRows)) {
          this.showErrorSummary()
          return
        }

        const payload = {
          assetTypeId: this.assetTypeId,
        }
        
        console.log(payload)
        this.coreRows.forEach(row => {
          row.items.forEach(item => {
            if (item.data.id === "assetTypeId") {
              payload[item.data.id] = item.data.value
            } else {
              payload[item.data.id] = item.data.value
            }
          })
        })

        // Update Asset Type details.
        this.$store.dispatch("asset/updateAssetTypeByAssetTypeId", {
          assetTypeId: payload.assetTypeId,
          assetTypeName: payload.assetTypeName,
          assetTypeDesc: payload.assetTypeDesc,
        })
          .then(() => {
            this.$bvToast.toast(`Your modifications have been saved.`, {
              title: "Asset Type Edit",
              autoHideDelay: 5000,
              variant: "success",
            })
            this.originalRows = JSON.parse(JSON.stringify(this.coreRows))
            return this.loadCurrentRecord()
          })
          .catch((error) => {
            console.error("[AssetTypeDetails.vue] Error saving Asset Type:", error)
            this.$bvToast.toast(`Failed to save modifications: ${error.message}`, {
              title: "Asset Type Edit", 
              autoHideDelay: 5000,
              variant: "danger",
            })
          })
      } else if (id === "backToSearchButton") { 
        this.$router.push("/assettypes/search")
      } else if (id === "createIncidentButton") {
        if (this.email === "") {
          this.$store.dispatch("auth/retrieveEmail")
        }
        this.$bvModal.show("createIncidentModal")
      }
    },
  },
}
</script>

<template>
  <div id="AssetTypeDetails">
    <DetailsTopBar
      :items="detailsTopBarItems"
      @buttonClick="onTopBarButtonClick"
    />
    <div class="PageContent">
      <div v-if="error.length > 0" class="errorPrompt">
        {{ error }}
      </div>
      <template v-else>
        <template v-if="loaded">
          <DetailsContainer 
            title="Asset Type Details"
            :rows="coreRows" 
            :expanded="detailsExpanded"
            @expandToggle="detailsExpanded = !detailsExpanded"
          />
        </template>
        <div v-else class="errorPrompt">
          Unable to Retrieve Asset Type Record
        </div>
      </template>
    </div>
    <IncidentModal
      :group="incidentGroup"
      subject="Asset Type Update Request"
      :displayName="incDisplayName"
    />
  </div>
</template>

<style>
.errorPrompt {
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
}
</style>
